import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type CardHeaderProps = PropsWithChildren<
	WithClassName<{
		title: string
		description?: string
	}>
>

export const CardHeader = ({ title, description, className, children }: CardHeaderProps) => (
	<div
		className={cn(
			'flex flex-col gap-4 border-b border-border p-4 sm:flex-row sm:items-end sm:justify-between',
			className
		)}>
		<div className="min-w-0">
			<h2 className="font-display text-[15px] font-bold leading-tight text-foreground">{title}</h2>
			{description && <p className="mt-1 text-[12px] text-muted-foreground">{description}</p>}
		</div>
		{children && <div className="flex flex-col gap-3 sm:flex-row sm:items-center">{children}</div>}
	</div>
)
